import {mainResources, MainResourceType} from "./main-resource-type";
import {teamReportResources, TeamReportResourceType} from "./team-report-resource-type";
import {adminResources, AdminResourceType} from "./admin-resource-type";
import {bloggerModalResources, BloggerModalResourceType} from "./blogger-modal-resource-type";
import {ResourceParams} from "../resources";
import {databaseResources, DatabaseResourceType} from "./database-resource-type";
import {othersResources, OthersResourceType} from "./othets-resource-type";
import {commonResources, CommonResourceType} from "./common-resource-type";
import {
  productCardModalTableResources,
  ProductCardModalTableResourceType
} from "./product-card-resource-types";
import {ratingReputationResources, RatingReputationResourceType} from "./rating-reputation-resource-type";
import {marketplaceManagerResources, MarketplaceManagerResourceType} from "./marketplace-manager-type";
import {
  purchasingProductManagers,
  PurchasingProductManagersResourceType
} from "./purchasing-product-managers-resource-type";

export type TableResourceType =
  MainResourceType |
  TeamReportResourceType |
  DatabaseResourceType |
  AdminResourceType |
  BloggerModalResourceType |
  CommonResourceType |
  ProductCardModalTableResourceType |
  RatingReputationResourceType |
  MarketplaceManagerResourceType |
  PurchasingProductManagersResourceType |
  OthersResourceType;

export const tableResources: {
  [key in TableResourceType]: ResourceParams;
} = {
  ...mainResources,
  ...teamReportResources,
  ...databaseResources,
  ...adminResources,
  ...bloggerModalResources,
  ...commonResources,
  ...productCardModalTableResources,
  ...ratingReputationResources,
  ...marketplaceManagerResources,
  ...purchasingProductManagers,
  ...othersResources
};
